(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("blockly/core"));
	else if(typeof define === 'function' && define.amd)
		define("multiselect", ["blockly/core"], factory);
	else if(typeof exports === 'object')
		exports["multiselect"] = factory(require("blockly/core"));
	else
		root["multiselect"] = factory(root["Blockly"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__370__) => {
return 